import CheckCircle from "@mui/icons-material/CheckCircle";
import CircleOutlined from "@mui/icons-material/CircleOutlined";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import LinkOutlined from "@mui/icons-material/LinkOutlined";
import PhoneOutlined from "@mui/icons-material/PhoneOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { fontSizes } from "healthex-common//sizes";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import React from "react";
import styled from "styled-components";
import { FlexColumn, FlexRow } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { AnchorBlue, ContentContainer as HXContentContainer, MailtoLink, Subtitle as HXSubtitle, Text, TinyText, } from "./HXMobilePage.styles";
import { multilineEllipsis } from "./base.styles";
export const ContentContainer = styled(HXContentContainer) `
    gap: 24px;
    padding-bottom: 24px;
`;
export const MediumSubtitle = styled(HXSubtitle) `
    font-size: ${fontSizes.MEDIUM};
`;
export const ConsentButton = styled(HXMobileButton) `
    color: ${colors.tulip_main};
    border-color: ${colors.tulip_50};
`;
export const CheckCircleIcon = styled(CheckCircle) `
    width: 24px;
    height: 24px;
`;
export const CircleOutlinedIcon = styled(CircleOutlined) `
    width: 24px;
    height: 24px;
`;
export const ProofOfConsentDownloadContainer = styled(FlexColumn) `
    gap: 8px;
`;
const ProofOfConsentCircularProgress = styled(CircularProgress) `
    color: ${colors.black_30};
    width: 16px !important;
    height: 16px !important;
    margin-right: 4px;
`;
export const DownloadProofOfConsentButton = styled(HXMobileButton).attrs({
    variant: "outlined",
}) ``;
export const DownloadProofOfConsentLoadingButton = styled(HXMobileButton).attrs({
    variant: "outlined",
    startIcon: React.createElement(ProofOfConsentCircularProgress),
}) ``;
export const ProofOfConsentStatusText = styled(TinyText) `
    color: ${(props) => (props.isError ? colors.tulip_main : colors.black_lighter)};
`;
export const ProofOfConsentStatusEmail = styled(MailtoLink) `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.4px;
`;
export const ProofOfConsentStatusExternalLink = styled.a `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.4px;
    text-decoration: underline;
`;
const PatientStudyContactLink = styled(AnchorBlue) `
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    overflow-wrap: break-word;
`;
export const PatientStudyContactMailtoLink = PatientStudyContactLink;
export const PatientStudyContactExternalLink = PatientStudyContactLink;
export const PatientStudyEmailText = styled(Text) `
    ${multilineEllipsis(2)}
`;
export const PatientDetailsOrgLogoContainer = styled(FlexRow) `
    width: 88px;
    height: 88px;
    align-self: center;
    overflow: hidden;
    border-radius: 1000px;
    border: 1px solid ${colors.blue_30};
    background: ${colors.white_main};
`;
export const PatientDetailsOrgLogoImg = styled.img.attrs({ width: "100%", height: "100%" }) `
    object-fit: contain;
`;
export const EmailIcon = styled(EmailOutlined) `
    color: ${colors.black_light};
    width: 24px;
    height: 24px;
`;
export const PhoneIcon = styled(PhoneOutlined) `
    color: ${colors.black_light};
    width: 24px;
    height: 24px;
`;
export const InfoIcon = styled(InfoOutlined) `
    color: ${colors.black_light};
    width: 24px;
    height: 24px;
`;
export const LinkIcon = styled(LinkOutlined) `
    color: ${colors.black_light};
    width: 24px;
    height: 24px;
`;
